import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography/Typography';
import { withStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon/Icon';
import Button from '@material-ui/core/Button/Button';
import { convertPrice } from '../utils';

const styles = {
  container: {
    width: '100%',
    textAlign: 'center',
    border: '1px solid rgba(178,178,178,0.5)',
    '&& > div > div:nth-child(1)': {
      backgroundColor: 'rgba(178,178,178,0.5)',
      color: 'rgba(33,35,34,0.5)',
    },
    '&& > div > div:nth-child(2)': {
      backgroundColor: '#EDEDED',
    },
    '&& > div > div:nth-child(2) p': {
      color: 'rgba(33,35,34,0.5)',
    },
    '&& button': {
      fontWeight: '500',
      backgroundColor: '#EDEDED',
      color: '#B2B2B2',
      padding: '0 9px',
    },
    '&& button > span': {
      display: 'flex',
      alignItems: 'center',
      height: 36,
    },
    '&& button > span > span': {
      fontSize: 20,
      marginRight: 8,
    },
  },
  selected: {
    borderColor: '#5AA3B5',
    boxShadow: '0 2px 6px 0 rgba(178,178,178,0.5)',
    '&& > div > div:nth-child(1)': {
      backgroundColor: '#5AA3B5',
      color: '#FFFFFF',
    },
    '&& > div > div:nth-child(2)': {
      backgroundColor: '#78C9DC',
      color: '#FFFFFF',
    },
    '&& > div > div:nth-child(2) p': {
      color: '#0D4464',
    },
    '&& button': {
      backgroundColor: '#00A1A1',
      color: '#FFFFFF',
    },
  },
  header: {
    padding: '8px !important',
    textTransform: 'uppercase',
    '&&> p ': {
      fontSize: 14,
      color: 'inherit',
    },
  },
  price: {
    height: 128,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    position: 'relative',
    '&& > p': {
      fontSize: 11,
      color: 'rgba(33,35,34,0.5)',
      position: 'absolute',
      left: 0,
      width: '100%',
      textAlign: 'center',
    },
    '&& > p:nth-child(1)': {
      top: 21,
    },
    '&& > p:last-child': {
      bottom: 31,
    },
    '&& > h2': {
      fontSize: 48,
      fontWeight: 500,
      color: 'inherit',
    },
    '&& small': {
      fontSize: 14,
    },
  },
  list: {
    borderBottom: '1px solid rgba(178,178,178,0.5)',
  },
  listItem: {
    display: 'flex',
    alignItems: 'center',
    margin: '7px 0',
    '&& > span': {
      fontSize: 18,
      color: 'rgba(33,35,34,0.5)',
      marginRight: 7,
    },
    '&& > p': {
      fontSize: 14,
      color: 'rgba(33,35,34,0.5) !important',
      fontWeight: 400,
    },
  },
  listItemHighlighted: {
    '&& > span': {
      color: '#31D662 ',
    },
    '&& > p': {
      color: '#212322 !important',
    },
  },
};

export const PlanItem = ({ classes, item, selected, onSelect, currency, paymentPeriod, listItems }) => {
  const summaries = [item.year_sum, item.month_sum];
  if (paymentPeriod === 'month') {
    summaries.reverse();
  }

  return (
    <Grid item className={`${classes.container} ${selected && classes.selected}`}>
      <Grid container spacing={5}>
        <Grid item xs={12} className={classes.header}>
          <Typography>{item.description}</Typography>
        </Grid>
        <Grid item xs={12} className={classes.price}>
          <Typography>{summaries[0] ? 'Starting at' : null}</Typography>
          <Typography variant="h6">{convertPrice(item[`${paymentPeriod}_sum`], currency)}
            <small>/{paymentPeriod}</small>
          </Typography>
          <Typography>{summaries[0] && paymentPeriod === 'month' ? `${convertPrice(summaries[1], currency)}/year` : null}</Typography>
        </Grid>
        <Grid item xs={12} className={classes.list}>
          <Grid container direction="column">
            {listItems.map((item, index) => <div key={`${index}-${item.value}`}
              className={`${classes.listItem} ${item.enabled ? classes.listItemHighlighted : null}`}>
              <Icon>{item.enabled ? 'done' : 'clear'}</Icon> <Typography>{item.value} </Typography>
            </div>)}
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Button onClick={onSelect} data-testid="choose-compliance-dashboard-plan-button">
            {selected ? <Icon>done</Icon> : null}
            {selected ? 'chosen plan' : 'choose this plan'}
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(PlanItem);
